import { IErrorObject, IErrorMessageHanlder } from "@/Instructure/baseModels/IErrorMessageHandler";

export class UserErrorMessage implements IErrorMessageHanlder {
    HandelMessages(obj: IErrorObject): string {
        switch (obj.Key) {

            default:
                return 'خطا'
        }
    }
}